import { SET_TAX_CONFIGURATION, SET_TAX_DIVIDE_CONFIGURATION, SET_TAX_SETTINGS, SET_BUSINESS_TAX_CONFIGURATIONS } from '../../actionTypes/taxSettings'

const initialState = {
  taxSettings: [],
  taxConfiguration: [],
  taxDivideConfiguration: [],
  businessTaxConfigurations: []
}

export function taxSettingsReducer (state = initialState, action) {
  switch (action.type) {
    case SET_TAX_SETTINGS:
      return {
        ...state,
        taxSettings: action.value,
      }
    case SET_TAX_CONFIGURATION:
      return {
        ...state,
        taxConfiguration: action.value,
      }
    case SET_TAX_DIVIDE_CONFIGURATION:
      return {
        ...state,
        taxDivideConfiguration: action.value,
      }
    case SET_BUSINESS_TAX_CONFIGURATIONS:
      return {
        ...state,
        businessTaxConfigurations: action.value,
      }
    default:
      return state
  }
}
